import Notes from '../../../../components/common/Notes'
import { useForm } from 'react-hook-form'
import { api } from '../../../../configs/api'
import { useAuth } from '../../../../context/AuthContext'
import { BusinessType } from '../BusinessDetail'
import toast from 'react-hot-toast'
import { useState } from 'react'
import BusinessNoteForm from './BusinessNoteForm'

type BusinessDataType = {
    businessID: number
    companyID?: number
    contacts?: any
    data?: BusinessType | null
    setData: (data: any) => void
    scrollRef: any
}

export type NoteType = {
    id: number
    date: string
    description: string
    users?: {
        id: number
        name: string
        email: string
    }[]
    dateNotify?: string
    status: 0 | 1
}

const BusinessNotes = ({ businessID, contacts, companyID, data, setData, scrollRef }: BusinessDataType) => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [currentNote, setCurrentNote] = useState<NoteType | null>(null)
    const [isPositive, setIsPositive] = useState<boolean>(true)
    const form = useForm({ mode: 'onChange' })
    const { user } = useAuth()
    if (!data) return null

    const handleSave = async (values: NoteType) => {
        if (!businessID || !user) return

        try {
            const formattedValues = {
                ...values,
                businessID,
                situation: isPositive ? 1 : 0,
                userID: user.userID
            }

            if (!formattedValues.date) {
                return toast.error('Por favor, preencha o campo data')
            }
            if (isPositive && !formattedValues.dateNotify) {
                return toast.error('Por favor, preencha o campo lembrete')
            }
            const formattedDateNotify = formattedValues.dateNotify
                ? formattedValues.dateNotify.split('/').reverse().join('-')
                : null

            if (isPositive && formattedDateNotify) {
                const [year, month, day] = formattedDateNotify.split('-').map(Number)
                const dataSelecionada = new Date(year, month - 1, day)
                const hoje = new Date()

                dataSelecionada.setHours(0, 0, 0, 0)
                hoje.setHours(0, 0, 0, 0)

                if (dataSelecionada < hoje) {
                    return toast.error('A data de lembrete deve ser maior ou igual a hoje')
                }
            }

            if (!formattedValues.description) {
                return toast.error('Por favor, preencha o campo descrição')
            }

            const response = await fetch(`${api}business/createNote`, {
                method: 'POST',
                body: JSON.stringify(formattedValues)
            })
            const result = await response.json()
            const noteID = result.noteID
            if (!noteID) {
                toast.error('Erro ao criar nota!')
                return
            }

            // Notas anteriores: status => 1
            setData((prevData: any) => ({
                ...prevData,
                notes: prevData.notes.map((note: NoteType) => ({ ...note, status: 1, isExpired: false }))
            }))

            // Atualiza nova nota
            const newData = {
                id: noteID,
                date: values.date,
                description: values.description,
                dateNotify: values.dateNotify,
                users: values.users,
                author: user.name,
                image: user?.image,
                status: values.status,
                isExpired: false
            }
            setData((prevData: any) => ({
                ...prevData,
                notes: [newData, ...(prevData.notes || [])]
            }))
            form.reset()

            toast.success('Nota criada com sucesso!')
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Notes
                data={data.notes || []}
                handleSave={handleSave}
                setData={setData}
                handleEdit={() => setOpenEdit(true)}
                handleDelete={() => setOpenDelete(true)}
                setCurrentNote={setCurrentNote}
                form={form}
                isPositive={isPositive}
                setIsPositive={setIsPositive}
            />

            <BusinessNoteForm
                open={openEdit}
                handleClose={() => setOpenEdit(false)}
                data={currentNote}
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
                setData={setData}
                isPositive={isPositive}
                setIsPositive={setIsPositive}
            />
        </>
    )
}

export default BusinessNotes
